import { countryCode } from 'emoji-flags';

interface Locale {
	baseName: string;
	region: string;
}

export class LocaleWithEmoji {
	private locale: Locale;
	
	constructor(locale: string) {
		this.locale = new (Intl as any).Locale(locale);	
	}

	public get baseName() {
		return this.locale.baseName;
	}

	public get baseNameWithEmoji() {
		const output = [this.baseName];
		const emoji = this.emoji;
		if(emoji) {
			output.push(emoji);
		}

		return output.reverse().join(' ');
	}

	public get emoji() {
		return countryCode(this.locale.region)?.emoji;
	}
}